"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const useVersionControl_1 = tslib_1.__importDefault(require("src/modules/version/hooks/useVersionControl"));
const VersionControl = () => {
    const hook = (0, useVersionControl_1.default)();
    // if (!shouldOpen || !currentRevision || currentRevision === version.revision) return null
    if (!hook.revision || process.env.APP_REVISION === hook.revision)
        return null;
    return ((0, jsx_runtime_1.jsxs)("div", { className: 'update-container d-flex justify-content-center align-items-center', children: [(0, jsx_runtime_1.jsx)("h6", { className: 'text-center m-1 font-size-sm', children: (0, jsx_runtime_1.jsx)("strong", { children: "\u10EE\u10D4\u10DA\u10DB\u10D8\u10E1\u10D0\u10EC\u10D5\u10D3\u10DD\u10DB\u10D8\u10D0 \u10D2\u10D0\u10DC\u10D0\u10EE\u10DA\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D5\u10D4\u10E0\u10E1\u10D8\u10D0" }) }), (0, jsx_runtime_1.jsx)("a", { className: 'cursor-pointer px-1 ml-2 font-size-sm', onClick: e => {
                    e.preventDefault();
                    window.location.reload();
                }, href: '#', children: "\u10D2\u10D0\u10DC\u10D0\u10EE\u10DA\u10D4\u10D1\u10D0" })] }));
};
exports.default = VersionControl;
